(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("universal-serialize", [], factory);
	else if(typeof exports === 'object')
		exports["universal-serialize"] = factory();
	else
		root["universal-serialize"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 